import React, { useState } from 'react'
import ReactDOM from 'react-dom'

function AccessibilityControl() {
    const [show, setShow] = useState(false)
    // State buat track tombol mana yang aktif
    const [activeFeatures, setActiveFeatures] = useState({
        'high-contrast': false,
        'font-large': false,
        'dyslexia-font': false,
        'grayscale': false
    })

    const toggleClass = (className) => {
        const container = document.getElementById('root')
        if (container) {
            container.classList.toggle(className)
            // Update state biar tombol kelihatan aktif
            setActiveFeatures(prev => ({
                ...prev,
                [className]: !prev[className]
            }))
        }
    }

    return ReactDOM.createPortal(
        <div className="a11y-wrapper">
            {show && (
                <div className="a11y-panel">
                    <h4 style={{ margin: '0 0 10px 0', fontSize: '15px' }}>Menu Aksesibilitas</h4>
                    <div className="a11y-grid">
                        {/* Kita tambahin class 'active' kalau state-nya true */}
                        <button className={`a11y-btn-control ${activeFeatures['high-contrast'] ? 'active' : ''}`} 
                                onClick={() => toggleClass('high-contrast')}>Kontras +</button>
                        
                        <button className={`a11y-btn-control ${activeFeatures['font-large'] ? 'active' : ''}`} 
                                onClick={() => toggleClass('font-large')}>Teks Besar</button>
                        
                        <button className={`a11y-btn-control ${activeFeatures['dyslexia-font'] ? 'active' : ''}`} 
                                onClick={() => toggleClass('dyslexia-font')}>Ramah Disleksia</button>
                        
                        <button className={`a11y-btn-control ${activeFeatures['grayscale'] ? 'active' : ''}`} 
                                onClick={() => toggleClass('grayscale')}>Grayscale</button>
                    </div>
                </div>
            )}

            <button className="a11y-btn" onClick={() => setShow(!show)}>
                <i className="fa fa-universal-access"></i>
            </button>
        </div>,
        document.body
    )
}

export default AccessibilityControl